import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div
      className="min-h-[60vh] flex items-center justify-center bg-zinc-50 border-b border-zinc-200"
      data-testid="not-found-page"
    >
      <div className="max-w-xl px-6 text-center">
        <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#0044FF] mb-4">
          Error · 404
        </div>
        <h1 className="font-display text-6xl tracking-tighter font-medium text-zinc-950">
          Page not found
        </h1>
        <p className="mt-4 text-zinc-600">
          The drawing you're looking for isn't in our archive.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-5 py-3 bg-[#0044FF] text-white font-medium btn-lift"
        >
          Back to home <ArrowRight size={14} weight="bold" />
        </Link>
      </div>
    </div>
  );
}
